import _, {transform} from "lodash";
import React from "react";
import MenuSettingSvg from "../../asset/icon/MenuSetting.svg";
import NursingStaffSvg from "../../asset/icon/NursingStaff.svg";
import ArchiveSvg from "../../asset/icon/Archive.svg";
import ApprovalSvg from "../../asset/icon/Approval.svg";
import AppContext from "../../application/AppContext";
import GovLetterSvg from "../../asset/icon/GovLetter.svg";
import HomepageSvg from "../../asset/icon/Homepage.svg";
import FileManageSvg from "../../asset/icon/FileManageSvg.svg";
import StatSvg from "../../asset/icon/StatSvg.svg";
import MisconductSvg from "../../asset/icon/MisconductSvg.svg";
import DataOverviewSvg from "../../asset/icon/DataOverview.svg";
import IndexSvg from "../../asset/icon/Index.svg";
import BusinessConstants from "../../constant/BusinessConstants";
import DevelopmentCenterSvg from "../../asset/icon/DevelopmentCenter.svg";
import SwjwHomepageSvg from "../../asset/icon/SwjwHomepage.svg";

const getMenu = (versionUpgradeVisible) => {
    const showUnitMemberMenu = _.includes(_.map(AppContext.user.nurseUnits, unit => unit.name), "市卫健委");
    const isUnderlay = __IS_UNDERLAY__;
    const archiveRoutes = [
        {
            key: "nursingstaff",
            name: "人员管理",
            icon: (
                <NursingStaffSvg style={{fontSize: 20}} />
            ),
            children: [
                {
                    key: "filemanagement",
                    name: "档案管理",
                    perm: ["nurse:archive:view", "emp:archive"],
                    component: () => import("../nursingstaff/filemanagement/FileManagementView"),
                    props: {perms: ["nurse:archive:view", "emp:archive"]},
                },
                {
                    key: "personnelmanagement",
                    name: "人事变动",
                    perm: "nurse:personnel:view",
                    component: () => import("../nursingstaff/personnelmanagement/PersonnelManagementView"),
                },
                {
                    key: "rotation",
                    name: "人员轮转",
                    perm: "nurse:rotation:view",
                    component: () => import("../nursingstaff/rotation/RotationView"),
                },
                {
                    key: "employeeloan",
                    name: "人员借调",
                    perm: "nurse:secondment:view",
                    component: () => import("../nursingstaff/employeeloan/EmployeeLoanView"),
                },
                {
                    key: "award",
                    name: "奖惩投诉",
                    perm: "nurse:award:view",
                    component: () => import("../nursingstaff/award/AwardView"),
                },
                /*  {
            key: "misconductdeduct",
            name: "不良行为扣分",
            perm: "emp:deduct",
            component: () => import("../nursingstaff/misconductdeduct/MisconductDeductView"),


        }, */
                {
                    key: "train",
                    name: "培训考核",
                    perm: "nurse:train",
                    children: [
                        {
                            key: "view",
                            name: "录入查看",
                            perm: "nurse:train:view",
                            component: () => import("../nursingstaff/train/view/TrainView"),
                        },
                        {
                            key: "hourcredit",
                            name: "学时学分汇总",
                            perm: "nurse:train:summary:view",
                            component: () => import("../nursingstaff/train/hourcredit/HourCreditView"),
                        },

                    ],
                },
                {
                    key: "pregnancyduedate",
                    name: "预产期登记",
                    perm: "nurse:duedate:view",
                    component: () => import("../nursingstaff/pregnancyduedate/PregnancyDueDateView"),
                },
                {
                    key: "govletter",
                    name: "医院信函",
                    perm: ["nurse:govLetterReception", "gov:letter"],
                    component: () => import("../govletter/GovLetterView"),
                },
            ],
        },
        {
            key: "stats",
            name: "统计分析",
            icon: (
                <StatSvg style={{fontSize: 20}} />
            ),
            perm: ["nurse:stat", "emp:stat:inservice", "emp:stat:dimission"],
            children: [
                {
                    key: "staffinfo",
                    name: "人员信息查询",
                    perm: "nurse:info:view",
                    component: () => import("../nursingstaff/staffinfo/StaffInfoView"),
                },
                {
                    key: "staffdist",
                    name: "人员分布统计",
                    perm: "nurse:stat:distribution",
                    component: () => import("../nursingstaff/stats/staffdist/StaffDistView"),
                    props: {perms: ["nurse:stat:distribution"]},
                },
                {
                    key: "inservice",
                    name: "在职人员统计",
                    perm: ["nurse:stat:inservice", "emp:stat:inservice"],
                    component: () => import("../nursingstaff/stats/inservice/InServiceView"),
                    props: {perms: ["nurse:stat:inservice", "emp:stat:inservice"]},
                },
                {
                    key: "dimission",
                    name: "注销人员统计",
                    perm: ["nurse:stat:dimission", "emp:stat:dimission"],
                    component: () => import("../nursingstaff/stats/dimission/DimissionView"),
                    props: {perms: ["nurse:stat:dimission", "emp:stat:dimission"]},
                },
                {
                    key: "multiwork",
                    name: "多点执业医生统计",
                    perm: "emp:stat:multi:work",
                    component: () => import("../nursingstaff/stats/multiwork/MultiWorkView"),
                },
                {
                    key: "qualitycontrol",
                    name: "国家护理质量数据",
                    perm: "nurse:stat:qc",
                    component: () => import("../nursingstaff/stats/qualitycontrol/QualityControlView"),
                },
                {
                    key: "clothes",
                    name: "鞋衣帽统计",
                    perm: "nurse:stat:clothes",
                    component: () => import("../nursingstaff/stats/clothes/ClothesView"),
                },
            ],
        },
        {
            key: "approval",
            name: "审批",
            icon: <ApprovalSvg style={{fontSize: 20}} />,
            perm: ["nurse:flow:1", "nurse:flow:2", "nurse:flow:3", "nurse:secondment:audit:bigUnit", "nurse:secondment:audit:dept"],
            component: () => import("../approval/ApprovalView"),
        },
        {
            key: "myarchive",
            name: "我的档案",
            icon: <ArchiveSvg style={{fontSize: 20}} />,
            component: () => import("../myarchive/MyArchiveView"),
        },
        /*  {
    key: "govletter",
    name: "医院信函",
    icon: <GovLetterSvg style={{fontSize: 20}} />,
    perm: ["nurse:govLetterReception", "gov:letter"],
    component: () => import("../govletter/GovLetterView"),
}, */
        {
            key: "setting",
            name: "设置",
            icon: (
                <MenuSettingSvg style={{fontSize: 20}} />
            ),
            children: _.filter([
                versionUpgradeVisible === "true" && {
                    key: "versionupgrade",
                    name: "版本升级",
                    component: () => import("../setting/versionupgrade/VersionUpdateView"),
                },
                /* {
            key: "staffactivate",
            name: "人员激活情况",
            perm: ["set:nurse:activate", "emp:stat:active"],
            component: () => import("../setting/staffactivate/StaffActivateView"),
            props: {perms: ["set:nurse:activate", "emp:stat:active"]},
        }, */

                {
                    key: "nursingfieldsetting",
                    name: "人员字段设置",
                    perm: ["ry:set:nurse:archive:field", "set:archive:field"],
                    component: () => import("../setting/nursingfieldsetting/NursingFieldSettingView"),
                },

                {
                    key: "employeeloansetting",
                    name: "人员借调设置",
                    perm: "nurse:secondment:set",
                    component: () => import("../setting/employeeloansetting/EmployeeLoanSettingView"),
                },
                {
                    key: "approvalflow",
                    name: "档案审批流程设置",
                    perm: "ry:set:nurse:flow",
                    component: () => import("../setting/approvalflow/ApprovalFlowView"),
                },
                {
                    key: "rolemanagement",
                    name: "角色权限设置",
                    perm: "ry:set:role:perm",
                    props: {module: BusinessConstants.BIZ_MODULE_TYPE.RENYUAN},
                    component: () => import("../setting/rolemanagement/RoleManagementView"),
                },
            ], Boolean),
        },
    ].filter(Boolean);

    const swjwRoutes = [
        {
            key: "index",
            name: <SwjwHomepageSvg style={{fontSize: 20, transform: "translateY(5px)"}} />,
            component: () => import("../swjwhomepage/SwjwHomepageView"),
        },
        {
            key: "static",
            name: "卫计人员管理",
            children: [
                {
                    key: "homepage",
                    name: "首页",
                    perm: "homepage",
                    icon: (
                        <HomepageSvg style={{fontSize: 20}} />
                    ),
                    component: () => import("../homepage/HomepageView"),
                    props: {perms: ["homepage"]},
                },
                {
                    key: "filemanagement",
                    name: "档案管理",
                    perm: ["emp:archive"],
                    icon: (
                        <FileManageSvg style={{fontSize: 20}} />
                    ),
                    component: () => import("../nursingstaff/filemanagement/FileManagementView"),
                    props: {perms: ["emp:archive"]},
                },
                {
                    key: "misconductdeduct",
                    name: "不良行为扣分",
                    perm: "emp:deduct",
                    icon: (
                        <MisconductSvg style={{fontSize: 20}} />
                    ),
                    component: () => import("../nursingstaff/misconductdeduct/MisconductDeductView"),

                },
                {
                    key: "govletter",
                    name: "医院信函",
                    icon: <GovLetterSvg style={{fontSize: 20}} />,
                    perm: ["nurse:govLetterReception", "gov:letter"],
                    component: () => import("../govletter/GovLetterView"),
                },
                {
                    key: "stats",
                    name: "统计分析",
                    icon: (
                        <StatSvg style={{fontSize: 20}} />
                    ),
                    perm: ["emp:stat:inservice", "emp:stat:dimission"],
                    children: [
                        {
                            key: "staffdist",
                            name: "人员分布统计",
                            perm: "nurse:stat:distribution",
                            component: () => import("../nursingstaff/stats/staffdist/StaffDistView"),
                            props: {perms: ["nurse:stat:distribution"]},
                        },
                        {
                            key: "inservice",
                            name: "在职人员统计",
                            perm: ["nurse:stat:inservice", "emp:stat:inservice"],
                            component: () => import("../nursingstaff/stats/inservice/InServiceView"),
                            props: {perms: ["nurse:stat:inservice", "emp:stat:inservice"]},
                        },
                        {
                            key: "dimission",
                            name: "注销人员统计",
                            perm: ["nurse:stat:dimission", "emp:stat:dimission"],
                            component: () => import("../nursingstaff/stats/dimission/DimissionView"),
                            props: {perms: ["nurse:stat:dimission", "emp:stat:dimission"]},
                        },
                        {
                            key: "multiwork",
                            name: "多点执业医生统计",
                            perm: "emp:stat:multi:work",
                            component: () => import("../nursingstaff/stats/multiwork/MultiWorkView"),
                        },
                    ],
                },
                {
                    key: "setting",
                    name: "设置",
                    icon: (
                        <MenuSettingSvg style={{fontSize: 20}} />
                    ),
                    children: _.filter([
                        {
                            key: "staffactivate",
                            name: "人员激活情况",
                            perm: ["ry:set:nurse:activate", "emp:stat:active"],
                            component: () => import("../setting/staffactivate/SwjwStaffActivateView"),
                            props: {perms: ["ry:set:nurse:activate", "emp:stat:active"]},
                        },
                        {
                            key: "nursingunitsetting",
                            name: "人员科室设置",
                            perm: ["set:nurse:dept", "set:dept"],
                            component: () => import("../setting/nursingunitsetting/NursingUnitSettingView"),
                        },
                        {
                            key: "nursingfieldsetting",
                            name: "人员字段设置",
                            perm: ["ry:set:nurse:archive:field", "set:archive:field"],
                            component: () => import("../setting/nursingfieldsetting/NursingFieldSettingView"),
                        },
                        {
                            key: "swjwrolemanagement",
                            name: "市卫健委角色权限设置",
                            perm: "ry:set:role:perm",
                            component: () => import("../setting/swjwrolemanagement/SwjwRoleManagementView"),
                        },
                        {
                            key: "swjwsetting",
                            name: "市卫健委相关设置",
                            perm: ["set:hosp:type", "set:hosp:group", "set:district"],
                            component: () => import("../setting/swjwsetting/SwjwSettingView"),
                        },
                        showUnitMemberMenu && {
                            key: "staffmanagement",
                            name: "人员设置",
                            component: () => import("../setting/UnitSettingIframeView"),
                            props: {
                                /*    url: new URL("/pc/index.html#/systemsetting/staffmanagement", "http://192.168.17.105:6445").toString(), */
                                url: new URL("/renyuan/pc/index.html#/systemsetting/staffmanagement", location.origin).toString(),
                            },
                        },
                        showUnitMemberMenu && {
                            key: "unitsetting",
                            name: "科室设置",
                            component: () => import("../setting/UnitSettingIframeView"),
                            props: {
                                url: new URL("/renyuan/pc/index.html#/unitsetting", location.origin).toString(),
                                /*   url: new URL("/pc/index.html#/unitsetting", "http://192.168.17.105:6445").toString(), */
                            },
                        },
                    ], Boolean),
                },
            ],
        },
        {
            key: "ZLJC",
            name: "质量检查",
            component: () => import("./IframeView"),
            props: {
                moduleConfig: {
                    id: 100003,
                    module: "ZLJC",
                    name: "质量检查",
                    status: 1,
                    pcHome: "/zhiliangjiancha/pc/index.html",
                    mobileHome: "/zhiliangjiancha/mobile/index.html",
                    pcRedirect: false,
                    mobileRedirect: false,
                },
            },
        },
        {
            key: "tjjgxt",
            name: "体检监管系统",
            component: () => import("./IframeView"),
            props: {
                moduleConfig: {
                    id: 100004,
                    module: "CUSTOM",
                    name: "体检监管系统",
                    status: 1,
                    pcHome: "http://10.172.252.10:7002/tjfx/login.html",
                    mobileHome: "http://10.172.252.10:7002/tjfx/login.html",
                    pcRedirect: false,
                    mobileRedirect: false,
                },
            },
        },
        {
            key: "zhxyxt",
            name: "智慧血液系统",
            component: () => import("./IframeView"),
            props: {
                moduleConfig: {
                    id: 100005,
                    module: "CUSTOM",
                    name: "智慧血液系统",
                    status: 1,
                    pcHome: "http://192.168.25.222:9095/login.html",
                    mobileHome: "http://192.168.25.222:9095/login.html",
                    pcRedirect: false,
                    mobileRedirect: false,
                },
            },
        },
    ];

    if (!isUnderlay) {
        return archiveRoutes;
    }

    const onlyMobileModule = [BusinessConstants.UNDERLAY_APP_MODULE_TYPE.USER_TRANSFER];


    const onVisibilityScope = (visiblityScope) => {
        const filteredScope = _.omitBy(visiblityScope, item => _.isEmpty(item));
        if (_.isEmpty(filteredScope)) {
            return true;
        }
        for (const key of _.keys(filteredScope)) {
            if (key === "unitIds") {
                if (_.includes(filteredScope[key], AppContext.user.nurseUnit.id)) {
                    return true;
                }
            } else if (key === "roleIds") {
                if (!_.isEmpty(_.intersection(filteredScope[key], _.map(AppContext.user.roles, "id")))) {
                    return true;
                }
            }
        }

        return false;
    };


    const commonRoutes = _.chain(AppContext.hospitalConfig?.redirectConfigs)
        .filter(item => item.status === 1 && !_.includes(onlyMobileModule, item.module) && onVisibilityScope(item.visibilityScope))
        .map((it) => {
            if (it.module === BusinessConstants.UNDERLAY_APP_MODULE_TYPE.ARCHIVE) {
                return {
                    key: "function",
                    name: !_.isEmpty(it.alias) ? it.alias : "360档案",
                    children: archiveRoutes,
                };
            } else if (it.module === BusinessConstants.UNDERLAY_APP_MODULE_TYPE.MED_GROUP) {
                return {
                    key: "medigroup",
                    name: !_.isEmpty(it.alias) ? it.alias : "临床科组管理",
                    children: [{
                        key: "dataoverview",
                        name: "全院数据概览",
                        perm: "doc:team:stat:hospital",
                        icon: <DataOverviewSvg style={{fontSize: 20}} />,
                        component: () => import("../medigroup/dataoverview/DataOverviewView"),
                    },
                    {
                        key: "medigroupmgmt",
                        name: "科室人组管理",
                        perm: ["doc:team:view", "doc:team:edit"],
                        icon: <NursingStaffSvg style={{fontSize: 20}} />,
                        component: () => import("../medigroup/medigroupmgmt/MediGroupMgmtView"),
                    },
                    {
                        key: "approval",
                        name: "审批",
                        icon: <ApprovalSvg style={{fontSize: 20}} />,
                        perm: ["emp:corssUnitPartTime:audit:unit", "emp:corssUnitPartTime:audit:admin"],
                        component: () => import("../approval/ApprovalView"),
                    },
                    {
                        key: "stat",
                        name: "统计分析",
                        icon: (
                            <StatSvg style={{fontSize: 20}} />
                        ),
                        children: [{
                            key: "docstatestat",
                            name: "医生状态统计",
                            perm: "doc:team:stat:docState",
                            component: () => import("../medigroup/stat/docstatestat/DocStateStatView"),
                        }, {
                            key: "docteamstat",
                            name: "医疗组统计",
                            perm: "doc:team:stat:teamStat",
                            component: () => import("../medigroup/stat/docteamstat/DocTeamStatView"),
                        }, {
                            key: "monthchangestat",
                            name: "每月变更记录",
                            perm: "doc:team:stat:change",
                            component: () => import("../medigroup/stat/monthchangestat/MonthChangeStatView"),
                        }, {
                            key: "querydocworkstatus",
                            name: "医生工作状态查询",
                            perm: "doc:team:stat:docStat",
                            component: () => import("../medigroup/stat/querydocworkstatus/QueryDocWorkStatusView"),
                        }],
                    },
                    {
                        key: "setting",
                        name: "设置",
                        perm: ["doc:team:set:base"],
                        icon: (
                            <MenuSettingSvg style={{fontSize: 20}} />
                        ),
                        children: [{
                            key: "basicsetting",
                            name: "基础设置",
                            perm: "doc:team:set:base",
                            component: () => import("../medigroup/setting/basicsetting/BasicSettingView"),
                        }],
                    }],
                };
            } else {
                return {
                    key: it.module === BusinessConstants.UNDERLAY_APP_MODULE_TYPE.CUSTOM
                        ? `${_.toLower(it.module)}_${it.id}`
                        : _.toLower(it.module),
                    name: !_.isEmpty(it.alias) ? it.alias : it.name,
                    component: () => import("./IframeView"),
                    props: {
                        moduleConfig: it,
                    },
                };
            }
        })
        .concat({
            key: "systemsetting",
            name: "系统设置",
            perm: "ry:set:system",
            children: [
                // {
                //     key: "setting",
                //     name: "系统设置",
                //     icon: (
                //         <MenuSettingSvg style={{fontSize: 20}} />
                //     ),
                //     children: [
                {
                    key: "basicsetting",
                    name: "基础设置",
                    component: () => import("../systemsetting/setting/SettingView"),
                },
                /*  {
                         key: "usersetting",
                         name: "人员设置",
                         component: () => import("../systemsetting/usersetting/UserSettingView"),
                     }, */
                {
                    key: "staffmanagement",
                    name: "人员设置",
                    component: () => import("../setting/staffmanagement/StaffManagementView"),
                },
                {
                    key: "rolemanagement",
                    name: "角色权限设置",
                    // perm: "underlay:set:role:perm",
                    props: {module: BusinessConstants.BIZ_MODULE_TYPE.UNDERLAY},
                    component: () => import("../setting/rolemanagement/RoleManagementView"),
                },
                {
                    key: "logosetting",
                    name: "应用logo及名称设置",
                    component: () => import("../systemsetting/logosetting/LogoSettingView"),
                },
                {
                    key: "mobilebannersetting",
                    name: "移动端首页图片设置",
                    component: () => import("../systemsetting/mobilebannersetting/MobileBannerSettingView"),
                },
                !(__IS_UNDERLAY__ && __IS_CDN__) && { // 基座云模式下不显示
                    key: "appmodule",
                    name: "应用管理",
                    component: () => import("../systemsetting/appmodule/AppModuleSettingsView"),
                },
                {
                    key: "developcenter",
                    name: "开发中心",
                    icon: <DevelopmentCenterSvg style={{fontSize: 20}} />,
                    children: [
                        {
                            key: "systemmap",
                            name: "外部系统对应关系",
                            component: () => import("../developcenter/systemmap/SystemMapView"),
                        },
                        {
                            key: "dau",
                            name: "应用访问人数",
                            component: () => import("../developcenter/dau/DauView"),
                        },
                    ],
                },
            ],
        },
        )
        .value();


    return AppContext.isSwjw
        ? swjwRoutes
        : commonRoutes;
};


const filterRouteConfigs = configs => _.chain(configs)
    .filter((r) => {
        if (_.isArray(r.perm)) {
            return _.some(r.perm, it => AppContext.permission.has(it));
        } else {
            return r.perm == null || AppContext.permission.has(r.perm);
        }
    })
    .map((r) => {
        if (_.isEmpty(r.children)) {
            return r;
        }
        const children = filterRouteConfigs(r.children);
        if (_.isEmpty(children)) {
            return null;
        } else {
            return {
                ...r,
                children,
            };
        }
    }).filter(r => r != null)
    .value();


export default {
    // menu,
    getMenu,
    filterRouteConfigs,
};
